import { AutogenModelMovementStops, AutogenRowMovementStops } from "./autogen/AutogenModelMovementStops";

export class ModelMovementStops extends AutogenModelMovementStops<RowMovementStops> {
	constructor() {
		super(RowMovementStops);
	}
}

export class RowMovementStops extends AutogenRowMovementStops {
}